export enum MCUserStatus {
  UNSUBSCRIBED = 0,
  SUBSCRIBED = 1,
}

export enum MCSourceEnum {
  REGISTRO = 'Registro',
  QR = 'QR',
}
